export default "__VITE_ASSET__BYuPFbRN__"